import Vue from 'vue';
import Vuetify from 'vuetify';

import store from './store/index';
import App from './App.vue';
import router from './router';


import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';


Vue.config.productionTip = false;

Vue.use(Vuetify);

Vue.mixin({
  data() {
    return {
      get phpTokenBooker() {
        /* global phpTokenBooker */
        return (typeof phpTokenBooker === 'undefined') ? null : phpTokenBooker;
      },
    };
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
